import React, { useEffect, useRef, useState } from 'react';
import { FaBell, FaUserCircle, FaCog, FaSignOutAlt, FaChevronDown, FaEnvelope, FaCalendarCheck } from 'react-icons/fa';
import { Link } from 'react-router-dom';
import { FaPlus } from "react-icons/fa6";
import { MdOutlineArrowOutward } from "react-icons/md";
import { FiEdit3 } from "react-icons/fi";
import { MdOutlineFileUpload } from "react-icons/md";
import { FaDownload } from "react-icons/fa6";


const BranchOfficeLead = () => {
  const [showNotifications, setShowNotifications] = useState(false);
  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const notificationRef = useRef(null);
  const profileRef = useRef(null);
  
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (notificationRef.current && !notificationRef.current.contains(event.target)) {
        setShowNotifications(false);
      }
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowProfileMenu(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const countryData = [
    { id: 1,  stname: "John", name: "Corsočia", status: "Active", institute: "Dave University",mobile: "00000000000",email: "info@gmail.com", addedDate: "06/16/2005", view: <Link>View Application</Link> },
    { id: 2, stname: "Jessica", name: "Arneńca", status: "In progress", institute: "Dave University",mobile: "00000000000",email: "info@gmail.com", addedDate: "06/16/2005", view: <Link>View Application</Link> },
    { id: 3, stname: "Noah", name: "Belgium", status: "Blocked",institute: "Dave University",mobile: "00000000000",email: "info@gmail.com", addedDate: "06/16/2005", view: <Link>View Application</Link> },
    { id: 4, stname: "Noah", name: "Corrada", status: "De-Active",institute: "Dave University",mobile: "00000000000",email: "info@gmail.com", addedDate: "06/16/2005", view: <Link>View Application</Link> },
    { id: 5, stname: "John", name: "Arneńca", status: "Active",institute: "Dave University",mobile: "00000000000",email: "info@gmail.com", addedDate: "06/16/2005", view: <Link>View Application</Link> },
    { id: 6, stname: "Jessica", name: "Belgium", status: "Active",institute: "Dave University",mobile: "00000000000",email: "info@gmail.com", addedDate: "06/16/2005", view: <Link>View Application</Link> },
    { id: 7, stname: "Noah", name: "Corrada", status: "Active",institute: "Dave University",mobile: "00000000000",email: "info@gmail.com", addedDate: "06/16/2005", view: <Link>View Application</Link> },
    { id: 8, stname: "John", name: "Arneńca", status: "De-Active",institute: "Dave University",mobile: "00000000000",email: "info@gmail.com", addedDate: "06/16/2005", view: <Link>View Application</Link> },
    { id: 9,stname: "Jessica", name: "Belgium", status: "Blocked",institute: "Dave University",mobile: "00000000000",email: "info@gmail.com", addedDate: "06/16/2005", view: <Link>View Application</Link> },
    { id: 10, stname: "Noah", name: "Arneńca", status: "Blocked",institute: "Dave University",mobile: "00000000000",email: "info@gmail.com", addedDate: "06/16/2005", view: <Link>View Application</Link> },
    { id: 11, stname: "John", name: "France", status: "Active",institute: "Dave University",mobile: "00000000000",email: "info@gmail.com", addedDate: "07/01/2005", view: <Link>View Application</Link> },
    { id: 12,stname: "Jessica", name: "Germany", status: "Active",institute: "Dave University",mobile: "00000000000", addedDate: "07/02/2005", view: <Link>View Application</Link> },
    { id: 13, stname: "Noah", name: "Italy", status: "Blocked",institute: "Dave University",mobile: "00000000000",email: "info@gmail.com", addedDate: "07/03/2005", view: <Link>View Application</Link> },
    { id: 14, stname: "John", name: "Spain", status: "De-Active",institute: "Dave University",mobile: "00000000000",email: "info@gmail.com", addedDate: "07/04/2005", view: <Link>View Application</Link> },
    { id: 15,stname: "Jessica", name: "Portugal", status: "Active",institute: "Dave University",mobile: "00000000000", addedDate: "07/05/2005", view: <Link>View Application</Link> },
    { id: 16, stname: "Noah", name: "Netherlands", status: "Active",institute: "Dave University",mobile: "00000000000",email: "info@gmail.com", addedDate: "07/06/2005", view: <Link>View Application</Link> },
    { id: 17, stname: "John", name: "Sweden", status: "Active",institute: "Dave University",mobile: "00000000000", addedDate: "07/07/2005", view: <Link>View Application</Link> },
    { id: 18,stname: "Jessica", name: "Norway", status: "De-Active",institute: "Dave University",mobile: "00000000000",email: "info@gmail.com", addedDate: "07/08/2005", view: <Link>View Application</Link> },
    { id: 19, stname: "Noah", name: "Denmark", status: "Blocked",institute: "Dave University",mobile: "00000000000",email: "info@gmail.com", addedDate: "07/09/2005", view: <Link>View Application</Link> },
    { id: 20, stname: "John", name: "Finland", status: "Blocked",institute: "Dave University",mobile: "00000000000",email: "info@gmail.com", addedDate: "07/10/2005", view: <Link>View Application</Link> },
  ];

  const [countries, setCountries] = useState(countryData);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;
  
  // Toggle status function
  const toggleStatus = (id) => {
    setCountries(prev => prev.map(country => 
      country.id === id 
        ? { 
            ...country, 
            status: country.status === 'Active' ? 'De-active' : 'Active' 
          } 
        : country
    ));
  };

  // Calculate pagination variables
  const totalPages = Math.ceil(countries.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = countries.slice(indexOfFirstItem, indexOfLastItem);

  const getStatusClass = (status) => {
    switch (status.toLowerCase()) {
      case 'active':
        return 'status-badge active';
      case 'blocked':
        return 'status-badge blocked';
      case 'de-active':
        return 'status-badge de-active';
      default:
        return 'status-badge';
    }
  };

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  return (
    <>
    <div className="container dashboard">
         <div className="container ">
      <div className="row">
        <div className="d-flex flex-row align-items-center justify-content-end">
          {/* Notification Dropdown */}
          <div className="position-relative me-3" ref={notificationRef}>
            <button 
              className="btn btn-link text-decoration-none p-2 bg-white rounded-3 shadow-sm d-flex align-items-center"
              onClick={() => setShowNotifications(!showNotifications)}
            >
              <FaBell className="fs-4 text-muted" />
              <span className="position-absolute text-danger top-0 start-100 translate-middle badge rounded-pill bg-danger">
                  .
                </span>
            </button>
            
            {/* Notification Dropdown Menu */}
            {showNotifications && (
               <div className="dropdown-menu show notificationadmin shadow-lg p-0">
               <div className="p-3 border-bottom">
                 <h6 className="fw-bold mb-0">Notifications</h6>
               </div>
               <div className="overflow-auto" style={{ maxHeight: '300px' }}>
                 <a href="#" className="dropdown-item d-flex py-3 border-bottom">
                   <div className='text-start'>
                     <p className="mb-0 fw-medium">New message received</p>
                     <small className="text-muted">You have 2 unread messages</small>
                     <div className="text-muted small mt-1">2 hours ago</div>
                   </div>
                 </a>
                 <a href="#" className="dropdown-item d-flex py-3 border-bottom">
                   <div className='text-start'>
                     <p className="mb-0 fw-medium">Meeting reminder</p>
                     <small className="text-muted">Team meeting at 3:00 PM</small>
                     <div className="text-muted small mt-1">5 hours ago</div>
                   </div>
                 </a>
                 <a href="#" className="dropdown-item d-flex py-3">
                   <div className='text-start'>
                     <p className="mb-0 fw-medium">System update</p>
                     <small className="text-muted">Maintenance scheduled for tomorrow</small>
                     <div className="text-muted small mt-1">Yesterday</div>
                   </div>
                 </a>
                 {/* Additional items to show scrollbar */}
                 <a href="#" className="dropdown-item d-flex py-3 border-top">
                   <div className='text-start'>
                     <p className="mb-0 fw-medium">New feature available</p>
                     <small className="text-muted">Check out the latest updates</small>
                     <div className="text-muted small mt-1">2 days ago</div>
                   </div>
                 </a>
                 <a href="#" className="dropdown-item d-flex py-3">
                   <div className='text-start'>
                     <p className="mb-0 fw-medium">Document approved</p>
                     <small className="text-muted">Your submission has been approved</small>
                     <div className="text-muted small mt-1">3 days ago</div>
                   </div>
                 </a>
               </div>
               <div className="text-center py-2 border-top">
                 <a href="#" className="text-primary text-decoration-none small">View all notifications</a>
               </div>
             </div>
            )}
          </div>
          
          {/* User Profile Dropdown */}
          <div className="position-relative" ref={profileRef}>
            <button 
              className="btn btn-link text-decoration-none p-2 bg-white rounded-3 shadow-sm d-flex align-items-center"
              onClick={() => setShowProfileMenu(!showProfileMenu)}
            >
              <div className="d-flex flex-column align-items-end me-2">
                <span className="fw-bold text-dark">derek aivarado</span>
                <span className="small text-muted">Branch Office</span>
              </div>
              <div className="position-relative">
                <div className="bg-light border rounded-circle p-1">
                  <FaUserCircle className="fs-1 text-primary" />
                </div>
                <FaChevronDown className="text-muted small position-absolute bottom-0 end-0 bg-white rounded-circle p-1 border" style={{ fontSize: '0.6rem' }} />
              </div>
            </button>
            
            {/* Profile Dropdown Menu */}
            {showProfileMenu && (
              <div className="dropdown-menu show shadow-lg" style={{ width: '220px', right: 0, left: 'auto', display: 'block' }}>
                <div className="text-center p-3 border-bottom">
                  <FaUserCircle className="fs-1 text-primary mb-2" />
                  <h6 className="mb-0 fw-bold">derek aivarado</h6>
                  <small className="text-muted">RY Admin</small>
                </div>
                <a href="#" className="dropdown-item d-flex align-items-center py-2">
                  <FaUserCircle className="me-3 text-muted" />
                  <span>My Profile</span>
                </a>
              
                <div className="dropdown-divider my-1"></div>
                <a href="#" className="dropdown-item d-flex align-items-center py-2 text-danger">
                  <FaSignOutAlt className="me-3" />
                  <span>Logout</span>
                </a>
              </div>
            )}
          </div>
        </div>
        </div>
     </div>
    

    {/* Header & Breadcrumb */}
          <h2 className="fw-bold mb-1">Lead Management</h2>
          <div className="small mb-4">
            <Link to="/branch-office/dashboard" className="text-decoration-none text-dark">DASHBOARD</Link> / <span className="fw-bold">LEAD MANDAGEMENT</span>
          </div>
          {/* Filters */}
               <div className="row ">
                <div className="row align-items-center g-2 mb-1 filters">
                 <div className="col-auto">
                   <Link to={'/branch-office/lead-management/add'} className="btn btn-outline-primary">
                     <FaPlus className="me-1"/> ADD LEAD 
                   </Link>
                 </div>
                 <div className="col-auto">
                   <button className="btn btn-outline-success">
                     <MdOutlineFileUpload className="me-1"/> UPLOAD LEADS
                   </button>
                 </div>
                 <div className="col-auto">
                   <input type='text' placeholder='Keyword' className="form-control" />
                 </div>
                <div className="col-auto">   
                 <select className="form-select">
                           <option disabled selected>Counsellor</option>
                           <option>Counsellor 1</option>
                           <option>Counsellor 2</option>
                           <option>Counsellor 3</option>
                         </select>
                 </div>
                <div className="col-auto">   
                 <select className="form-select">
                           <option disabled selected>Interested Country</option>
                           <option>UK</option>
                           <option>USA</option>
                         </select>
                 </div>
                {/* <div className="col-auto">   
                 <select className="form-select">
                           <option disabled selected>Lead Type</option>
                           <option>Front Office</option>
                           <option>Website</option>
                         </select>
                 </div> */}
                 {/* <div className="col-auto">   
                 <select className="form-select">
                           <option disabled selected>Source of Lead</option>
                           <option>Front Office</option>
                           <option>Website</option>
                         </select>
                 </div> */}
                <div className="col-auto">
                   <button className="btn btn-outline-success">
                     <FaDownload  className="me-1"/> Download CSV
                   </button>
                 </div>
                  <div className="col-auto">   
                 <input type='text' placeholder='Search' className="form-control" />
                 </div>
               </div>
               </div>

          <div className="table-wrapper mt-4">
                 <div className="country-management-container">
    <div className="table-container">
      <table className="country-table">
        <thead>
          <tr>
            <th>#</th>
            <th>Student Name</th>
            <th>Status</th>
            <th>Interested Country</th>
            <th>Interested Institute</th>
            <th>Mobile</th>
            <th>E-mail</th>
            <th>FollowUp Date</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {currentItems.map((country, index) => (
            <tr key={country.id}>
              <td>{indexOfFirstItem + index + 1}</td>
              <td>{country.stname}</td>
              <td>
                 <div className="">
             
              <span className={`ms-2 ${getStatusClass(country.status)}`}>
                {country.status}
              </span>
            </div>
              </td>
              <td>{country.name}</td>
              <td>{country.institute}</td>

              <td>{country.mobile}</td>
              <td>{country.email}</td>
                <td>{country.addedDate}</td>
              
              <td className="d-flex flex-row align-items-center justify-content-start gap-2">
                <div className=''>
                        <Link className='bg-white border link rounded-3 p-2 d-flex align-items-center justify-content-center'>
                            <MdOutlineArrowOutward />

                        </Link>
                </div>
                <div className='d-flex flex-row align-items-center justify-content-center'>
                        <Link className='bg-white border link rounded-3 p-2 d-flex align-items-center justify-content-center'>
                            <FiEdit3 />

                        </Link>
                </div>
                 {/* <div className='d-flex flex-row align-items-center justify-content-center'>
                        <Link className='bg-white border link rounded-3 p-2 d-flex align-items-center justify-content-center'>
                            <MdOutlineDelete />

                        </Link>
                </div> */}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>

      <div className="pagination">
        {Array.from({ length: Math.min(5, totalPages) }, (_, i) => i + 1).map(page => (
          <button
            key={page}
            className={`page-button ${currentPage === page ? 'active' : ''}`}
            onClick={() => handlePageChange(page)}
          >
            {page}
          </button>
        ))}
        
        {totalPages > 5 && (
          <>
            <span className="ellipsis">...</span>
            <button
              className={`page-button ${currentPage === totalPages ? 'active' : ''}`}
              onClick={() => handlePageChange(totalPages)}
            >
              {totalPages}
            </button>
          </>
        )}
      </div>
    </div>
          </div>
        </div>
    </>
  )
}

export default BranchOfficeLead
